import { localStorage } from './localstorage';

/**
 * version 互換性がない変更をしたくなったときに更新する
 * events ログに落としたい情報
 */
interface IUserBehaviorLoggerStorage {
  version: number;
  events: IUserBehavioralEvent[];
}
/**
 * type ログタイプ
 * pagetype ULTのページパラメータと同じ
 * conttype ULTのページパラメータと同じ
 * datetime ログを落とした時間のタイムスタンプ(new Date().getTime()で取得可能)
 * payload :
 *  {
 *    sec:Viewableログを落とすタグに設定しているsec
 *    slk:Viewableログを落とすタグに設定しているslk
 *  }
 */
interface ViewEvent {
  type: 'view';
  pagetype: string;
  conttype: string | null;
  datetime: number;
  payload: {
    sec: string;
    slk?: string;
  };
}
/**
 * type ログタイプ
 * pagetype ULTのページパラメータと同じ
 * conttype ULTのページパラメータと同じ
 * datetime ログを落とした時間のタイムスタンプ(new Date().getTime()で取得可能)
 * payload :
 *  {
 *    sec:Clickログを落とすタグに設定しているsec
 *    slk:Clickログを落とすタグに設定しているslk
 *  }
 */
interface ClickEvent {
  type: 'click';
  pagetype: string;
  conttype: string | null;
  datetime: number;
  payload: {
    sec: string;
    slk?: string;
  };
}
/**
 * type ログタイプ
 * pagetype ULTのページパラメータと同じ
 * conttype ULTのページパラメータと同じ
 * datetime ログを落とした時間のタイムスタンプ(new Date().getTime()で取得可能)
 * payload 追加情報
 */
interface PageViewEvent {
  type: 'pageview';
  pagetype: string;
  conttype: string | null;
  datetime: number;
  payload: object;
}

export type IUserBehavioralEvent = ViewEvent | ClickEvent | PageViewEvent;

// ロガーが受け付けるPageData構造
interface PageData {
  pageParam: {
    conttype?: string;
    pagetype: string;
  };
}

const LOCALSTORAGE_KEY = 'YAHOO.JP.News.localLogging';
const LOCALSTORAGE_VER = 1;
export default class UserBehaviorLogger {
  /**
   * @param pageData
   * @param sec
   * @param slk
   */
  public static logViewEvent(pageData: PageData, sec: string, slk?: string): void {
    this.setLog({
      type: 'view',
      pagetype: pageData.pageParam.pagetype,
      conttype: pageData.pageParam.conttype ?? null,
      datetime: new Date().getTime(),
      payload: {
        sec,
        slk
      }
    });
  }
  /**
   * @param pageData
   * @param sec
   * @param slk
   */
  public static logClickEvent(pageData: PageData, sec: string, slk?: string): void {
    this.setLog({
      type: 'click',
      pagetype: pageData.pageParam.pagetype,
      conttype: pageData.pageParam.conttype ?? null,
      datetime: new Date().getTime(),
      payload: {
        sec,
        slk
      }
    });
  }
  /**
   * @param pageData
   */
  public static logPageView(pageData: PageData) {
    this.setLog({
      type: 'pageview',
      pagetype: pageData.pageParam.pagetype,
      conttype: pageData.pageParam.conttype ?? null,
      datetime: new Date().getTime(),
      payload: {}
    });
  }
  /**
   *
   */
  public static getLogs(): IUserBehavioralEvent[] {
    return localStorage.get<IUserBehaviorLoggerStorage>(LOCALSTORAGE_KEY, LOCALSTORAGE_VER)?.events ?? [];
  }
  private static setLog(event: IUserBehavioralEvent) {
    const savedEvents = localStorage.get<IUserBehaviorLoggerStorage>(LOCALSTORAGE_KEY, LOCALSTORAGE_VER)?.events;
    /**
     * ローカルストレージに保存できるデータには上限があるためログ量を調整する
     * ログの量目安
     * 一ヶ月程度のログを保存
     * 多めに見積もって各種ログ(PV,Viewable,Click)あわせて1日２０件ほどを想定
     * 20件*30日 = 600レコード分保存
     * １ログ = 200バイト前後なのでログ量maxで120KB前後
     */
    const events = savedEvents ? [event, ...savedEvents].slice(0, 600) : [event];
    localStorage.set<IUserBehaviorLoggerStorage>(LOCALSTORAGE_KEY, LOCALSTORAGE_VER, {
      version: 1,
      events
    });
  }
}
